import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateInspectionServiceTags } from '../../api/inspection-service.ts';
import { UpdateInspectionServiceTagsRequest } from '../../api/requests/inspection-service-request.ts';

export default function useUpdateInspectionServiceTags(): UseMutationResult<
  Awaited<ReturnType<typeof updateInspectionServiceTags>>,
  Error,
  UpdateInspectionServiceTagsRequest
> {
  return useMutation({
    mutationFn: updateInspectionServiceTags,
  });
}
